import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    CheckCircleOutline,
    HighlightOff,
    MonetizationOn,
    StarRate,
    FormatListNumbered,
    HouseSiding,
    CleaningServices,
    PeopleAlt,
    EmojiPeople,
    InfoOutlined,
    AccessTime,
    ThumbUpAltOutlined,
    ThumbDownAltOutlined
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    導入
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('what-is-kajidaiko')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    家事代行サービスとは？
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('choose-service')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    家事代行サービスの選び方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('merit-demerit')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    メリット・デメリット
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('cost')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    費用相場とコスト管理
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experience')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    体験談・成功事例
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: 18 }}>
                                    7.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    専門家からのアドバイス
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    導入
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェア生活を始めると、「家事の分担」や「掃除の頻度」などで悩む方も多いのではないでしょうか。多忙な毎日や価値観の違いがストレスになることも。そんな時に活用したいのが「家事代行サービス」です。実は近年、この家事代行サービスを上手に取り入れて、快適なシェアハウス生活を実現している人が増えています。
                </Typography>
                <Typography variant="body1">
                    本記事では、家事代行サービスの選び方や注意点、コスト感、そして実際に導入した事例まで、ルームシェア経験者の視点から具体的に解説します。読了後には、あなたのシェア生活がもっと自由で快適になるヒントが見つかるはずです。
                </Typography>
            </Box>

            {/* 家事代行サービスとは？ */}
            <Box id="what-is-kajidaiko" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    家事代行サービスとは？
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={7}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            家事代行サービスとは、掃除・洗濯・料理・整理整頓など、日常の家事をプロのスタッフに依頼できるサービスです。定期的な訪問からスポット利用まで、ニーズに合わせて柔軟に選べる点が魅力。最近ではルームシェアやシェアハウス向けのプランも登場し、複数人で暮らす住まいにピッタリのサービスとなっています。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon><CleaningServices color="primary" /></ListItemIcon>
                                <ListItemText primary="掃除（リビング・水回り・共用部）" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><HouseSiding color="primary" /></ListItemIcon>
                                <ListItemText primary="整理整頓・ゴミ出し" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><EmojiPeople color="primary" /></ListItemIcon>
                                <ListItemText primary="料理や洗濯（オプション）" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><AccessTime color="primary" /></ListItemIcon>
                                <ListItemText primary="定期・スポットの柔軟な対応" />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <img
                                src="/images/blog/cleaning-service_roomshare-kajidaiko.jpg"
                                alt="明るい共用リビングで家事代行スタッフがクリーナーを使い、ルームメイトたちがリラックスして過ごしている様子。空間は清潔感があり、ホワイトとブルーのインテリアが映える。"
                                style={{ maxWidth: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* 家事代行サービスの選び方 */}
            <Box id="choose-service" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    家事代行サービスの選び方
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    家事代行サービスは多くの会社が提供しており、プランや価格、サービス内容も様々です。シェア生活に合うサービスを選ぶポイントを解説します。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7}>
                        <List>
                            <ListItem>
                                <ListItemIcon><PeopleAlt color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="ルームメイト全員のニーズを確認"
                                    secondary="事前に何を依頼したいかを全員で共有し、優先順位を決めましょう。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><FormatListNumbered color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="共用部中心か、個室も含めるか"
                                    secondary="共用スペースのみ依頼するケースが多いですが、個室対応も相談できます。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><StarRate color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="信頼性・口コミ評価"
                                    secondary="口コミや実績、保険加入の有無などもチェックポイント。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><MonetizationOn color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="料金・割り勘ルール"
                                    secondary="費用をどう分担するか、事前にルール化しておくとトラブルを防げます。"
                                />
                            </ListItem>
                        </List>
                        <Box sx={{ mt: 2 }}>
                            <Chip label="比較サイトで複数社をチェック" color="primary" variant="outlined" sx={{ mr: 1 }} />
                            <Chip label="お試しプラン活用" color="primary" variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Paper elevation={2} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                <InfoOutlined sx={{ mr: 0.5, verticalAlign: 'middle' }} fontSize="small" />
                                注意ポイント
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText primary="貴重品管理は各自で徹底" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText primary="サービス外の依頼は事前確認" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText primary="個人情報の共有範囲も要調整" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>

            {/* メリット・デメリット */}
            <Box id="merit-demerit" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    メリット・デメリット
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#f1f8e9' }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <ThumbUpAltOutlined color="success" sx={{ mr: 1, verticalAlign: 'middle' }} />
                                メリット
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                                    <ListItemText
                                        primary="家事のストレス軽減"
                                        secondary="掃除や片付けの負担が減り、ルームメイト間のトラブルも回避しやすい。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                                    <ListItemText
                                        primary="プロによる高品質な仕上がり"
                                        secondary="自分たちでは行き届かない部分まできれいに。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                                    <ListItemText
                                        primary="時間の有効活用"
                                        secondary="自分の趣味や仕事に集中でき、QOL向上にもつながる。"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#ffebee' }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <ThumbDownAltOutlined color="error" sx={{ mr: 1, verticalAlign: 'middle' }} />
                                デメリット
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="コスト負担"
                                        secondary="定期利用では月数千〜数万円の費用が発生。割り勘方法も要相談。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="他人を自宅に入れる不安"
                                        secondary="プライバシーやセキュリティ面で抵抗を感じる人も。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="サービス範囲の制限"
                                        secondary="ペットや特殊清掃は対象外の場合もあるので事前の確認が必要。"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>

            {/* 費用相場とコスト管理 */}
            <Box id="cost" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    費用相場とコスト管理
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    家事代行サービスは「料金が高い？」というイメージもありますが、ルームシェアならみんなで負担できるため意外とリーズナブルに。主な費用相場をまとめました。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                            <List>
                                <ListItem>
                                    <ListItemIcon><MonetizationOn color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="定期利用（週1回・2時間）"
                                        secondary="8,000〜12,000円/月（1人4,000〜6,000円程度/2人暮らしの場合）"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><MonetizationOn color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="スポット利用（1回2時間）"
                                        secondary="5,000〜8,000円/回"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><MonetizationOn color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="オプション（料理・洗濯等）"
                                        secondary="1,500円〜/回"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
                            ※サービスや地域、対応人数によって価格は異なります。シェアメイト同士の割り勘方法や支払い管理は、トラブル防止のためLINEグループや家計簿アプリで共有するのがおすすめです。
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <img
                                src="/images/blog/roomshare-cost_roomshare-kajidaiko.jpg"
                                alt="ルームシェアの住人たちがリビングテーブルで家計簿アプリを囲み、家事代行サービスの費用分担を話し合っている様子。明るい雰囲気と協力的な空気感。"
                                style={{ maxWidth: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* 体験談・成功事例 */}
            <Box id="experience" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    体験談・成功事例
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <img
                                src="/images/blog/sharehouse-happy_roomshare-kajidaiko.jpg"
                                alt="明るい共有リビングでルームメイトたちがコーヒーを片手に笑顔で談笑し、背後では家事代行スタッフが掃除をしている。温かみのあるウッド調のインテリア。"
                                style={{ maxWidth: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Card elevation={1} sx={{ mb: 2, borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                    <PeopleAlt color="primary" sx={{ mr: 1, verticalAlign: 'middle' }} />
                                    体験談①：掃除のトラブルが激減！
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    「以前は掃除の分担でもめがちだったのですが、思い切って家事代行を導入してからは、みんなストレスフリーに。共用部が常にきれいで、自然とコミュニケーションも増えました！」（20代・男女混合4人暮らし）
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card elevation={1} sx={{ borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                    <PeopleAlt color="primary" sx={{ mr: 1, verticalAlign: 'middle' }} />
                                    体験談②：費用も納得、生活の質が向上
                                </Typography>
                                <Typography variant="body2">
                                    「費用は月1万円程度を4人で割り勘。コスパもよく、時間と心の余裕ができたのが最大のメリット。週末はみんなで趣味や食事を楽しめるようになりました。」（30代・社会人グループ）
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            {/* 専門家からのアドバイス */}
            <Box id="tips" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    専門家からのアドバイス
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    最後に、家事代行サービスをルームシェアで活用する際のコツや注意点をまとめました。トラブル予防や満足度アップのためにも、ぜひ参考にしてください。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#e3f2fd', borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                <CheckCircleOutline color="primary" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
                                家事代行導入のコツ
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText primary="利用ルールを明確にする" secondary="曜日やサービス内容、費用分担は文書化やグループチャットで共有。" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText primary="お試しプランで体験" secondary="最初はスポット利用から始め、相性を確認しましょう。" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText primary="フィードバックを重視" secondary="サービス内容に改善点があれば、全員で話し合って調整。" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#fffde7', borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                <InfoOutlined color="warning" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
                                トラブル防止ポイント
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText primary="貴重品・現金の管理を徹底" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText primary="契約前のサービス範囲確認" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><HighlightOff color="error" /></ListItemIcon>
                                    <ListItemText primary="全員の同意を得てから申し込む" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-kajidaiko',
    slug: 'roomshare-kajidaiko',
    title: 'ルームシェアの「家事代行サービス」活用術',
    excerpt: '家事代行サービスの選び方、メリット・デメリット、費用相場、体験談を交え、ルームシェアで家事代行を活用するコツを徹底解説。',
    coverImage: '/images/blog/cover-roomshare-kajidaiko_roomshare-kajidaiko.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。インテリアはナチュラルウッドとホワイトを基調。全体に清潔感と温かみがあり、快適な共同生活の雰囲気を象徴している。',
    publishedAt: '2024-06-19T00:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '家事代行', '住まい'],
    tags: ['家事代行サービス', 'ルームシェア', '費用相場', '体験談', '快適生活'],
    author: {
        name: '佐藤 遼',
        avatar: '/images/avatars/ryo-sato.jpg',
        bio: 'ルームシェアを中心に快適な住まい・シェアハウス運営の経験を持つコンサルタント。住まいのトラブル予防やライフスタイル向上のコツを発信中。',
        profilePicture: '/images/avatars/ryo-sato.jpg'
    },
    viewCount: 1320,
    contentComponent: PostContent
};

export default post;